var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$gapi.isAuthenticated())?_c('v-btn',{on:{"click":_vm.logout}},[_vm._v(" Logout ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }